export { default as StrategyNewOpportunityBadge } from './StrategyNewOpportunityBadge';
